/*
 * Copyright (C) 2017 BossieTech Co.,Ltd. All Rights Reserved.
 * Creator  :   Alfred
 * Date     :   2018/10/22
 */
import request from '@/utils/request'
import qs from 'qs'

// 获取目标模板Id下的表单列表,支持分页，排序，过滤，用户权限会影响内容输出
export function getFormTableData(copy) {
  const params = JSON.parse(JSON.stringify(copy))
  const templateId = params.templateId
  delete params.templateId
  return request({
    url: `/templates/${templateId}/forms`,
    method: 'get',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// 获取模板的数据表信息(表头信息) childType=3,pageSize=100
export function getFormTableHeader(copy) {
  const params = JSON.parse(JSON.stringify(copy))
  const templateId = params.templateId
  delete params.templateId
  return request({
    url: `/templates/${templateId}/datasheets`,
    method: 'get',
    params
  })
}
// 获取目标模板Id下某个单子的某个明细表数据信息
export function getDetailTabledata(copy) {
  const params = JSON.parse(JSON.stringify(copy))
  const templateId = params.templateId
  const rid = params.rid
  const sheetId = params.sheetId
  delete params.templateId
  delete params.rid
  delete params.sheetId
  return request({
    url: `/templates/${templateId}/forms/${rid}/sheet/${sheetId}`,
    method: 'get',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function deleteRecord(templateId, id) {
  return request({
    url: `/templates/${templateId}/forms/${id}`,
    method: 'delete'
  })
}
// 获取流程表单关联的流程进度，会做权限和模板流程的关联检查
// 进度信息同流程中获取的进度信息
export function getPreviewWorkFlowTasksSchedule(templateId, id) {
  return request({
    url: `/templates/${templateId}/forms/${id}/schedule`,
    method: 'get'
  })
}
// 构建分类树
export function getClassIficationList(id, classificationid, data) {
  if(id!==undefined){
    return request({
      url: `/templates/${id}/classificationlist/${classificationid}`,
      method: 'post',
      data
    })
  }  
}
// 表单锁定解锁
export function lockUnlock(templateId, id, state) {
  return request({
    url: `/templates/${templateId}/forms/${id}/lock?state=${state}`,
    method: 'put'
  })
}
// 获取模板上的关联填报
export function getTemplateConnect(id, tid, type) {
  return request({
    url: `/users/${id}/templates/${tid}/connects?type=${type || 1}`,
    method: 'get'
  })
}
// 批量删除目标模板Id下单子的数据信息，并执行单子删除时的相关业务逻辑
export function deleteRecords(templateId, data) {
  return request({
    url: `/templates/${templateId}/forms`,
    method: 'delete',
    data
  })
}
// 下载导入模板
export function getImportTemplate(templateId) {
  return request({
    url: `/templates/${templateId}/mastersheet`,
    method: 'get',
    responseType: 'blob'
  })
}
// 导入数据
export function uploadImportData(templateId, data, params) {
  return request({
    url: `/templates/${templateId}/formdata`,
    method: 'post',
    data,
    params,
    timeout: 0
  })
}
// 导出数据
export function getFormData(templateId, params, data) {
  return request({
    url: `/templates/${templateId}/export`,
    method: 'post',
    params,
    timeout: 0,
    responseType: 'blob',
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    data
  })
}
// 获取模板属性
export function getTemplateAttribute(id) {
  return request({
    url: `/templates/${id}/attribute`,
    method: 'get'
  })
}

// 获取模板上的关联填报
export function getTemplateLinksList(id, tid, type) {
  return request({
    url: `/users/${id}/templates/${tid}/links?type=${type || 1}`,
    method: 'get'
  })
}

// 获取超链接关联的目标单据
export function getLinkSheetList(id, params, data) {
  return request({
    url: `/templatelinks/${id}/forms`,
    method: 'post',
    config: {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    },
    params,
    data
  })
}

export function getConnectLinkSheetList(id, params, data) {
  return request({
    url: `/TemplateConnects/${id}/forms`,
    method: 'post',
    config: {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    },
    params,
    data
  })
}

// 检查表单操作约束-编辑
export function checkFormEditable(templateId, id) {
  return request({
    url: `/templates/${templateId}/forms/${id}/operation`,
    method: 'post',
    params: {
      op: 'Modify'
    }
  })
}

// 执行自定义按钮
export function excuteActions(actionId, userId, templateId, records) {
  return request({
    url: `/templateactions/${actionId}/invoke`,
    method: 'post',
    params: {
      uid: userId,
      templateId: templateId,
      records: records
    },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getContextForm(templateId, params) {
  return request({
    url: `/templates/${templateId}/forms/id`,
    method: 'get',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

// 获取用户在特定模板上的操作约束
export function getTemplateClassification(id, templateId) {
  return request({
    url: `/users/${id}/templates/${templateId}/classification`,
    method: 'get'
  })
}

// 获取excel导入错误文件
export function getImporterrorFile(templateId, name) {
  return request({
    url: `/templates/${templateId}/importerror?name=${name}`,
    method: 'get',
    responseType: 'blob'
  })
}